import React, { useState } from "react";
import { Tabs, Tab, Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import CustomerPigmy from "./pigmyComponent/CustomerPigmy";
import CustomerLoan from "./loanComponent/CustomerLoan";
import CustomerPigmyCollection from "./pigmyComponent/CustomerPigmyCollectoins";
import CustomerLoanCollection from "./loanComponent/CustomerLoanCollections";

function OverviewTabs() {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleBack = () => {
    navigate(`/customer${location.search}`);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Button
        variant="outlined"
        size="small"
        startIcon={<ArrowBackIcon />}
        onClick={handleBack}
        sx={{ mb: 2, textTransform: "capitalize" }}
      >
        Back
      </Button>
      <Tabs value={value} onChange={handleChange} aria-label="overview tabs">
        <Tab label="Pigmy" />
        <Tab label="Loans" />
        <Tab label="Loan Report" />
        <Tab label="Pigmy Report" />
      </Tabs>

      {/* Tab Panels */}
      {value === 0 && (
        <TabPanel>
          <CustomerPigmy setTabValue={setValue} />
        </TabPanel>
      )}
      {value === 1 && (
        <TabPanel>
          <CustomerLoan setTabValue={setValue} />
        </TabPanel>
      )}
      {value === 2 && (
        <TabPanel>
          <CustomerLoanCollection />
        </TabPanel>
      )}
      {value === 3 && (
        <TabPanel>
          <CustomerPigmyCollection />
        </TabPanel>
      )}
    </Box>
  );
}

function TabPanel({ children }) {
  return <Box sx={{ p: 3 }}>{children}</Box>;
}

export default OverviewTabs;
